export default "__VITE_ASSET__DbWsptzr__"